/* STRYP PDP — subscription toggle, freq selector, tabs, thumbnails */
(function () {
  'use strict';

  // Subscription toggle
  var opts = document.querySelectorAll('.purchase-option');
  var freqWrap = document.getElementById('frequency-wrap');
  var spInput = document.getElementById('selling-plan-input');
  var priceEl = document.getElementById('pdp-price');
  var unitEl = document.getElementById('pdp-price-unit');
  var cmpEl = document.getElementById('pdp-price-compare');
  var atcPrice = document.getElementById('atc-price');

  opts.forEach(function (btn) {
    btn.addEventListener('click', function () {
      opts.forEach(function (b) { b.classList.remove('active'); b.setAttribute('aria-selected', 'false'); });
      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');

      var isSub = btn.id === 'opt-subscribe';
      if (freqWrap) freqWrap.style.display = isSub ? 'block' : 'none';
      if (spInput) spInput.value = btn.dataset.sellingPlan || '';
      if (priceEl) priceEl.textContent = isSub ? '$25.49' : '$29.99';
      if (unitEl)  unitEl.textContent  = isSub ? '/mo' : '';
      if (cmpEl)   cmpEl.textContent   = isSub ? '$29.99 one-time' : '';
      if (atcPrice) atcPrice.textContent = isSub ? '$25.49/mo' : '$29.99';
    });
  });

  // Tabs
  var tabs = document.querySelectorAll('.pdp-tab');
  var panels = document.querySelectorAll('.pdp-tab-panel');
  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      var name = t.dataset.pdpTab;
      tabs.forEach(function (x) { x.classList.remove('active'); x.setAttribute('aria-selected', 'false'); });
      panels.forEach(function (p) { p.classList.remove('active'); });
      t.classList.add('active');
      t.setAttribute('aria-selected', 'true');
      var panel = document.querySelector('[data-pdp-panel="' + name + '"]');
      if (panel) panel.classList.add('active');
    });
  });

  // Thumbnails
  var thumbs = document.querySelectorAll('.pdp-thumb');
  var mainImg = document.querySelector('.pdp-img-main img');
  thumbs.forEach(function (th) {
    th.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.classList.remove('active'); });
      th.classList.add('active');
      if (mainImg && th.dataset.full) mainImg.src = th.dataset.full;
    });
  });
})();
